export type CRITERIA_TYPE = CRITERIA.PROFILE | CRITERIA.COMPANY;
export enum CRITERIA {
  "PROFILE" = "PROFILE",
  "COMPANY" = "COMPANY",
}
